import { render, staticRenderFns } from "./SetupFileHarvester.vue?vue&type=template&id=6a1466ee&"
import script from "./SetupFileHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupFileHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports